import React from "react";
import PropTypes from "prop-types";

function Loader({ text = "Searching" }) {
    return (
        <div
            className="loader"
            role="alert"
            aria-busy="true"
            aria-live="polite"
        >
            <span>{text}</span>
            <div
                className="custom-spinner"
                role="status"
                aria-hidden="true"
            >
                <div className="loader-cap">

                </div>
            </div>
        </div>
    );
}

Loader.propTypes = {
    text: PropTypes.string,
};

export default Loader;
